var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.25H15.5V4.75H14V1.75H11V0.25H14ZM2 0.25H5V1.75H2V4.75H0.5V0.25H2ZM14 12.25V9.25H15.5V13.75H11V12.25H14ZM2 12.25H5V13.75H0.5V9.25H2V12.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenIcon);
export default __webpack_public_path__ + "static/media/fullscreen-icon.80d7c35feb2e25fc32a2b46277de8f7c.svg";
export { ForwardRef as ReactComponent };